  (function () {
    const toggleBtn = document.querySelector('[data-js="product-display-toggle"]');
    if (!toggleBtn) return;

    const container = document.querySelector('[data-js="collection"]');

    // Helper to flip a single slider without animation
    const flipSliderInstant = (slider, isProductMode) => {
      const slides = slider.querySelectorAll('.media-slider__slide');
      const activeSlide = slider.querySelector('.media-slider__slide[aria-current="true"]');
      if (!activeSlide || slides.length === 0) return false;
      const originalIndex = activeSlide.dataset.freshOriginalIndex;
      const lastIndex = String(slides.length - 1);

      let toggled = false;
      if (typeof slider.goToOriginalIndex === 'function') {
        if (isProductMode) {
          if (originalIndex !== lastIndex) {
            slider._preProductIndex = originalIndex;
            slider.goToOriginalIndex(lastIndex, { instant: true });
            toggled = true;
          }
        } else {
          const targetIndex = slider._preProductIndex !== undefined ? slider._preProductIndex : '0';
          if (originalIndex !== targetIndex) {
            slider.goToOriginalIndex(targetIndex, { instant: true });
            toggled = true;
          }
          delete slider._preProductIndex;
        }
      } else {
        // Fallback to legacy prev/next toggle
        if (isProductMode && originalIndex === '0') {
          if (typeof slider.prev === 'function') {
            slider.prev({ instant: true });
            toggled = true;
          }
        } else if (!isProductMode && originalIndex === lastIndex) {
          if (typeof slider.next === 'function') {
            slider.next({ instant: true });
            toggled = true;
          }
        }
      }

      return toggled;
    };

    if (container) {
      container.dataset.displayMode = toggleBtn.dataset.active;

      const grid = container.querySelector('[data-js="collection-grid"]');
      if (grid) {
        let timeoutId;
        let pendingSliders = [];

        new MutationObserver((mutations) => {
          if (container.dataset.displayMode !== 'product') return;

          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                if (node.matches('media-slider')) pendingSliders.push(node);
                const innerSliders = node.querySelectorAll('media-slider');
                innerSliders.forEach((s) => pendingSliders.push(s));
              }
            });
          });

          if (pendingSliders.length > 0) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
              const slidersToProcess = [...pendingSliders];
              pendingSliders = [];

              window.customElements.whenDefined('media-slider').then(() => {
                slidersToProcess.forEach((slider) => flipSliderInstant(slider, true));
              });
            }, 50);
          }
        }).observe(grid, { childList: true, subtree: true });
      }
    }

    const performToggleUpdate = (newState) => {
      toggleBtn.dataset.active = newState;
      toggleBtn.setAttribute('aria-checked', newState === 'product' ? 'true' : 'false');

      if (container) {
        container.dataset.displayMode = newState;
      }

      // Instantly flip the sliders
      const mediaSliders = document.querySelectorAll('media-slider');
      mediaSliders.forEach((slider) => flipSliderInstant(slider, newState === 'product'));

      // Emit event so the product grid/cards can respond to the display mode change
      window.dispatchEvent(new CustomEvent('collection:display-mode', { detail: { mode: newState } }));
    };

    toggleBtn.addEventListener('click', function () {
      const isProduct = toggleBtn.dataset.active === 'product';
      const newState = isProduct ? 'on-body' : 'product';

      if (document.startViewTransition) {
        document.startViewTransition(() => performToggleUpdate(newState));
      } else {
        performToggleUpdate(newState);
      }
    });
  })();

  (function () {
    const bar = document.querySelector('[data-js="collection-filter-bar"]');
    const sentinel = document.querySelector('[data-js="collection-filter-sentinel"]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;

    const readCssPx = (name) => {
      const raw = getComputedStyle(document.documentElement).getPropertyValue(name);
      const parsed = parseFloat(raw);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    let observer = null;

    /* Build (or rebuild) the observer with a root margin equal to
       the negative header height. The sentinel "intersects" while
       it sits below that line and stops intersecting the moment it
       scrolls behind the header — a single, monotonic transition
       per scroll direction, so the stuck state cannot oscillate on
       small back-and-forth scrolls (the previous scroll-math
       implementation flickered because both --header-offset and
       the bar's own animating transform shifted the threshold mid-
       scroll). Rebuild only on resize, when header height may
       genuinely change. */
    const build = () => {
      if (observer) observer.disconnect();
      const headerPx = Math.max(0, Math.round(readCssPx('--header-height')));
      observer = new IntersectionObserver(
        ([entry]) => {
          const stuck = !entry.isIntersecting;
          if ((bar.dataset.stuck === 'true') !== stuck) {
            bar.dataset.stuck = stuck ? 'true' : 'false';
          }
        },
        {
          rootMargin: `-${headerPx}px 0px 0px 0px`,
          threshold: 0,
        }
      );
      observer.observe(sentinel);
    };

    build();
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 150);
    });
  })();

  /**
   * Hydrate the collection grid from Searchspring's
   * endpoint with full client-side pagination support.
   *
   * Features:
   *   - "Load More" button (appends next page, replaceState)
   *   - "Load Previous" button (prepends earlier page, scroll-preserving)
   *   - Numbered page navigation (replaces grid, pushState)
   *   - History API integration (popstate restores page state)
   *   - SEO: <a> tags with valid hrefs
   *
   * @returns {void}
   */
  (function () {
    const root = document.querySelector('[data-js="collection"]');
    if (!root || root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    const grid = root.querySelector('[data-js="collection-grid"]');
    if (!grid) return;

    const skeletonGrid = root.querySelector('[data-js="collection-skeleton"]');
    const template = root.querySelector('[data-js="collection-card-template"]');
    const paginationWrapper = root.querySelector('[data-js="collection-pagination"]');
    const progressEl = paginationWrapper?.querySelector('[data-js="pagination-progress"]');
    const loadMoreBtn = paginationWrapper?.querySelector('[data-js="pagination-load-more"]');
    const loadMoreText = paginationWrapper?.querySelector('[data-js="pagination-load-more-text"]');
    const spinnerEl = paginationWrapper?.querySelector('[data-js="pagination-spinner"]');
    const navEl = paginationWrapper?.querySelector('[data-js="pagination-nav"]');
    // TODO - Change this to higher in page
    const scrollTarget = document.querySelector('.collection-upper');

    const i18n = {
      progress: paginationWrapper?.dataset.i18nProgress || "You've viewed [[end]] of [[total]] products",
      allLoaded: paginationWrapper?.dataset.i18nAllLoaded || 'All [[total]] items loaded',
      loadMore: paginationWrapper?.dataset.i18nLoadMore || 'Load more',
      previous: paginationWrapper?.dataset.i18nPrevious || 'Previous',
      next: paginationWrapper?.dataset.i18nNext || 'Next',
      page: paginationWrapper?.dataset.i18nPage || 'Go to page [[page]]',
    };

    function revealFallback() {
      grid.removeAttribute('hidden');
      if (skeletonGrid) skeletonGrid.setAttribute('hidden', '');
      lazyLoadCards(grid);
    }

    const handle = root.dataset.collectionHandle;
    const siteId = window.themeSettings?.athosSiteId ?? '';
    if (!handle || !siteId || !template) return revealFallback();

    const currencyFormat = root.dataset.currencyFormat || '';
    const basePath = window.location.pathname;

    const state = {
      lowestPage: 1,
      highestPage: 1,
      activePage: 1,
      totalPages: 0,
      totalResults: 0,
      perPage: 24,
      displayedCount: 0,
      isFetching: false,
      pendingLoad: null,
    };

    const cardDataMap = new WeakMap();
    const activeObservers = [];
    let initialGridRender = true;

    /**
     * Register an observer for cleanup on the next grid re-render.
     *
     * @param {IntersectionObserver} observer - Observer to track.
     * @returns {IntersectionObserver} The same observer.
     */
    function trackObserver(observer) {
      activeObservers.push(observer);
      return observer;
    }

    /** Disconnect and forget all tracked observers. */
    function disconnectObservers() {
      activeObservers.forEach(function (observer) {
        observer.disconnect();
      });
      activeObservers.length = 0;
    }

    /**
     * Lazy-load `<img data-src>` elements as their card scrolls into
     * view. Per card, only the active slide image is hydrated here.
     * @param {ParentNode} scope
     */
    function lazyLoadCards(scope) {
      const targets = [];
      scope.querySelectorAll('media-slider').forEach(function (slider) {
        const active =
          slider.querySelector('.media-slider__slide[aria-current="true"]') ||
          slider.querySelector('.media-slider__slide');
        if (!active) return;
        const img = active.querySelector('img[data-src]');
        if (img) targets.push(img);
      });
      if (targets.length === 0) return;

      const swap = function (img) {
        const src = img.dataset.src;
        if (!src) return;
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          delete img.dataset.srcset;
        }
        img.src = src;
        delete img.dataset.src;
        if (typeof img.decode === 'function') img.decode().catch(function () {});
      };

      if (typeof IntersectionObserver !== 'function') {
        targets.forEach(swap);
        return;
      }

      const observer = trackObserver(
        new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              swap(entry.target);
              obs.unobserve(entry.target);
            });
          },
          { rootMargin: '200px 0px' }
        )
      );
      targets.forEach(function (img) {
        observer.observe(img);
      });
    }

    /**
     * Immediately hydrate the leading cards' primary images with eager,
     * high-priority loading so the likely LCP image skips the
     * IntersectionObserver queue. Idempotent: promoted images lose their
     * data-src and are ignored on any later pass.
     * @param {Element[]} cards - Rendered cards in display order.
     * @param {number} count - How many leading cards to prioritise.
     */
    function prioritiseLeadImages(cards, count) {
      cards.slice(0, count).forEach(function (card) {
        const active =
          card.querySelector('.media-slider__slide[aria-current="true"]') || card.querySelector('.media-slider__slide');
        const img = active ? active.querySelector('img[data-src]') : null;
        if (!img) return;
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          delete img.dataset.srcset;
        }
        img.src = img.dataset.src;
        delete img.dataset.src;
        if (typeof img.decode === 'function') img.decode().catch(function () {});
      });
    }

    /**
     * Map a Searchspring result onto the product-card-template bindings.
     * @param {object} r
     * @returns {object}
     */
    function normalise(r) {
      // Athos results carry data under either the flat legacy shape or
      // r.mappings.core (newer shape) — read both, flat as the fallback.
      const core = (r.mappings && r.mappings.core) || {};
      const priceMajor = parseFloat(core.price ?? r.price ?? 0);
      const msrpMajor = parseFloat(core.msrp ?? r.msrp ?? 0);
      let price = Number.isFinite(priceMajor) ? Math.round(priceMajor * 100) : 0;
      let compareAt = Number.isFinite(msrpMajor) ? Math.round(msrpMajor * 100) : 0;
      // Athos indexes base-currency (AUD) feed prices; market shoppers get the
      // exact presentment price primed from the Storefront API instead.
      const presentment =
        typeof window.AthosAPI.getPresentmentPrice === 'function'
          ? window.AthosAPI.getPresentmentPrice(r.handle || '')
          : null;
      if (presentment) {
        price = presentment.price;
        compareAt = presentment.compareAt;
      }
      const onSale = compareAt > 0 && compareAt > price;

      const title = (r.name || '').split(' - ')[0];
      const colour = (r.name || '').split(' - ')[1] || '';
      const colourSwatch = '';
      const productHandle = r.handle || '';
      const productUrl = r.url || (productHandle ? '/products/' + productHandle : '#');

      const images = (Array.isArray(r.ss_images) && r.ss_images) || [r.imageUrl || r.thumbnailImageUrl].filter(Boolean);
      // Shopify's auto-generated video posters (/files/preview_images/…)
      // stay in the list: they render as still slides that
      // `assets/product-card-video.js` upgrades to playing video in place.
      const media = images.map(function (src) {
        let imageUrl = src;
        let srcset = null;
        if (imageUrl && imageUrl.indexOf('cdn.shopify.com') !== -1) {
          try {
            const url = new URL(imageUrl, window.location.origin);
            url.pathname = url.pathname.replace(
              /_(?:\d+x\d*(?:_crop_[a-zA-Z]+)?|small|medium|large|grande|original)(\.[a-zA-Z0-9]+)$/i,
              '$1'
            );
            // Build the srcset from the clean (width-free) URL so
            // buildSrcset's appended width params never duplicate.
            url.searchParams.delete('width');
            if (window.AthosAPI && typeof window.AthosAPI.buildSrcset === 'function') {
              srcset = window.AthosAPI.buildSrcset(url.toString(), [400, 600, 800, 1200]);
            }
            url.searchParams.set('width', '800');
            imageUrl = url.toString();
          } catch (e) {}
        }
        return {
          image: imageUrl,
          alt: title,
          product_url: productUrl,
          product_title: title,
          is_image: 'true',
          srcset: srcset || null,
          sizes_attr: srcset ? '(max-width: 767px) 50vw, 25vw' : null,
        };
      });

      let parsedSizes = [];
      const rawSizes = (r.attributes && r.attributes.ss_sizes) || r.ss_sizes;
      if (typeof rawSizes === 'string' && rawSizes) {
        try {
          parsedSizes = JSON.parse(rawSizes.replace(/&quot;/g, '"').replace(/&amp;/g, '&'));
        } catch (_e) {
          parsedSizes = [];
        }
      } else if (Array.isArray(rawSizes)) {
        parsedSizes = rawSizes;
      }

      let sizeLabel = '';
      if (parsedSizes.length > 0) {
        const firstLabel = String(parsedSizes[0].label || '');
        if (firstLabel && firstLabel !== 'One Size' && firstLabel.indexOf(' ') !== -1) {
          const parts = firstLabel.split(' ');
          parts.pop();
          sizeLabel = parts.join(' ').trim();
        }
      }

      const variants = parsedSizes.map(function (s) {
        const label = String(s.label || '');
        let size;
        if (label === 'One Size') {
          size = label;
        } else if (label.indexOf(' ') !== -1) {
          const parts = label.split(' ');
          size = (parts[parts.length - 1] || label).trim();
        } else {
          size = label;
        }
        const available = Number(s.available) > 0;
        return {
          id: String(s.id || ''),
          label: label,
          size: size,
          available: available,
          available_str: available ? 'true' : 'false',
          aria_disabled: available ? undefined : 'true',
          aria_label: label,
        };
      });

      const { colour_options: colourOptions, colour_overflow } = window.ProductCardBind.parseColourSwatches(
        r,
        productHandle,
        productUrl,
        colour
      );

      const attrs = r.attributes || {};
      const promo =
        window.PromoPricing && typeof window.PromoPricing.resolve === 'function'
          ? window.PromoPricing.resolve({ priceCents: price, tags: attrs.ss_tags || r.ss_tags })
          : null;
      const rawBanners =
        attrs.mfield_custom_urgency_banners ||
        r.mfield_custom_urgency_banners ||
        attrs.custom_urgency_banners ||
        r.custom_urgency_banners ||
        attrs.urgency_banners ||
        r.urgency_banners;

      let parsedBanners = [];
      if (typeof rawBanners === 'string' && rawBanners) {
        try {
          const parsed = JSON.parse(rawBanners.replace(/&quot;/g, '"').replace(/&amp;/g, '&'));
          parsedBanners = Array.isArray(parsed) ? parsed : [parsed];
        } catch (_e) {
          parsedBanners = [];
        }
      } else if (Array.isArray(rawBanners)) {
        parsedBanners = rawBanners;
      } else if (typeof rawBanners === 'object' && rawBanners !== null) {
        parsedBanners = [rawBanners];
      }

      let banners = [];
      if (Array.isArray(parsedBanners)) {
        parsedBanners = parsedBanners.map(function (b) {
          if (typeof b === 'string') {
            try {
              return JSON.parse(b.replace(/&quot;/g, '"').replace(/&amp;/g, '&'));
            } catch (_e) {
              return null;
            }
          }
          return b;
        });
        const nowMs = Date.now();
        banners = parsedBanners
          .filter(function (b) {
            if (!b || !b.text || b.paused === true || b.show === false) return false;
            if (b.scheduledStartAt) {
              const startMs = Date.parse(b.scheduledStartAt);
              if (!isNaN(startMs) && nowMs < startMs) return false;
            }
            if (b.scheduledEndAt) {
              const endMs = Date.parse(b.scheduledEndAt);
              if (!isNaN(endMs) && nowMs > endMs) return false;
            }
            return true;
          })
          .map(function (b) {
            return {
              text: String(b.text || ''),
              style_str:
                'background-color: ' +
                window.AthosAPI.safeColour(b.bg_color, '#FCFBF8') +
                '; color: ' +
                window.AthosAPI.safeColour(b.text_color, '#050000') +
                ';',
            };
          });
      }

      const ssBadgeText = window.AthosAPI.cleanBannerText(attrs.ss_badge_text || r.ss_badge_text);
      if (ssBadgeText) {
        const ssBadgeBg = window.AthosAPI.safeColour(attrs.ss_badge_bg || r.ss_badge_bg, '#FCFBF8');
        const ssBadgeColour = window.AthosAPI.safeColour(attrs.ss_badge_colour || r.ss_badge_colour, '#050000');
        banners.push({
          text: ssBadgeText,
          style_str: 'background-color: ' + ssBadgeBg + '; color: ' + ssBadgeColour + ';',
        });
      }

      const rawProductLabel = attrs.mfield_custom_product_label || r.mfield_custom_product_label;
      let parsedProductLabel = '';
      if (typeof rawProductLabel === 'string') {
        parsedProductLabel = window.AthosAPI.cleanBannerText(rawProductLabel);
      } else if (Array.isArray(rawProductLabel) && rawProductLabel.length > 0) {
        parsedProductLabel = typeof rawProductLabel[0] === 'string' ? rawProductLabel[0] : '';
      }

      if (typeof parsedProductLabel === 'string' && parsedProductLabel) {
        const labelParts = parsedProductLabel.split('|');
        const labelText = (labelParts[0] || '').trim();
        if (labelText) {
          const labelBg = window.AthosAPI.safeColour((labelParts[1] || '').trim(), '#FCFBF8');
          const labelColor = window.AthosAPI.safeColour((labelParts[2] || '').trim(), '#050000');
          banners.push({
            text: labelText,
            style_str: 'background-color: ' + labelBg + '; color: ' + labelColor + ';',
          });
        }
      }

      const seenBannerText = {};
      banners = banners.filter(function (b) {
        const key = (b.text || '').trim().toLowerCase();
        if (!key || seenBannerText[key]) return false;
        // Text still shaped like serialised JSON or carrying entities failed
        // to decode upstream — drop it rather than render raw markup.
        if (key.startsWith('["') || key.startsWith('[{') || key.startsWith('{"') || key.indexOf('&quot;') !== -1) {
          return false;
        }
        seenBannerText[key] = true;
        return true;
      });

      return {
        id: core.parentId || r.parentId || r.uid || core.uid || r.id || '',
        handle: productHandle,
        title: title,
        colour: colour,
        product_url: productUrl,
        product_title: title,
        price: price,
        compare_at_price: compareAt,
        swipeable: 'true',
        banners: banners,
        formatted_price: window.AthosAPI.formatMoney(price, currencyFormat, true),
        formatted_compare_at_price: window.AthosAPI.formatMoney(compareAt, currencyFormat, true),
        on_sale: onSale,
        price_type: onSale ? 'discount' : null,
        saved_percent: onSale ? Math.floor(((compareAt - (promo ? promo.priceCents : price)) / compareAt) * 100) : 0,
        promo_percent: promo ? promo.percent : 0,
        promo_price: promo ? promo.priceCents : price,
        formatted_promo_price: promo ? window.AthosAPI.formatMoney(promo.priceCents, currencyFormat, true) : null,
        promo_message: promo
          ? window.PromoPricing.message(window.AthosAPI.formatMoney(promo.priceCents, currencyFormat, true), promo.percent) || null
          : null,
        size_label: sizeLabel,
        variants: variants,
        colour_options: colourOptions,
        colour_overflow: colour_overflow,
        yotpo_bottomline_raw: attrs.mfield_yotpo_preloaded_bottomline || r.mfield_yotpo_preloaded_bottomline || null,
        hover_image: media[1] ? media[1].image || null : null,
        media:
          media.length > 0
            ? media
            : [{ image: '', alt: title, product_url: productUrl, product_title: title, is_image: 'true' }],
      };
    }

    /**
     * Prime the Storefront presentment-price cache for a fetched page of
     * results so `normalise` can overlay exact market prices synchronously.
     * No-op for base-currency shoppers.
     * @param {object} body - fetchCategory response body.
     * @returns {Promise<void>}
     */
    async function primePresentmentPrices(body) {
      if (!window.AthosAPI || typeof window.AthosAPI.fetchPresentmentPrices !== 'function') return;
      const results = (body && body.ok && body.data && body.data.results) || [];
      const handles = results
        .map(function (r) {
          return r.handle || '';
        })
        .filter(Boolean);
      if (handles.length === 0) return;
      await window.AthosAPI.fetchPresentmentPrices({ handles });
    }

    async function fetchResults(page) {
      let filters = {};
      if (window.CollectionSortFilter) {
        filters = window.CollectionSortFilter.getParams();
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 8000);
      try {
        const body = await window.AthosAPI.fetchCategory({
          handle,
          page: page || 1,
          resultsPerPage: state.perPage,
          filters,
          signal: controller.signal,
        });
        await primePresentmentPrices(body);
        return body;
      } finally {
        clearTimeout(timeoutId);
      }
    }

    /**
     * Build a DocumentFragment of product cards from SS results.
     * @param {object[]} results
     * @param {string} [responseId]
     * @returns {DocumentFragment}
     */
    function renderCards(results, responseId) {
      const fragment = document.createDocumentFragment();
      results.forEach(function (result) {
        const data = normalise(result);
        const card = window.ProductCardBind.renderCard(template, data);
        if (card) {
          if (responseId) {
            cardDataMap.set(card, { result, responseId });
          }
          fragment.appendChild(card);
        }
      });
      return fragment;
    }

    /**
     * Observe rendered cards with IntersectionObserver and fire impression
     * beacons for items that enter the viewport.
     */
    function observeImpressions(responseId, results, cards) {
      if (!window.AthosBeacon || !responseId) return;
      if (!('IntersectionObserver' in window)) {
        window.AthosBeacon.sendCategoryImpression(responseId, results);
        return;
      }
      const seen = new Set();
      const observer = trackObserver(
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              const card = entry.target;
              const index = cards.indexOf(card);
              if (index === -1 || seen.has(index)) return;
              seen.add(index);
              observer.unobserve(card);
              if (results[index]) {
                window.AthosBeacon.sendCategoryImpression(responseId, [results[index]]);
              }
            });
          },
          { threshold: 0.5 }
        )
      );
      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    /** Update the header product-count badge. */
    function updateProductCount(total) {
      const countEl = document.querySelector('[data-js="product-count"]');
      if (!countEl) return;
      const tpl = countEl.dataset.template;
      countEl.textContent = tpl ? tpl.replace('[[count]]', total) : total;
    }

    /** Update the "You've viewed X of Y" progress text. */
    function updateProgress() {
      if (!progressEl) return;
      // Use activePage * perPage so the count reflects the visitor's
      // position in the catalogue, not just the cards currently in the
      // DOM. This stays correct when landing directly on ?page=N and
      // when navigating back to an already-loaded ("old") page.
      const end = Math.min(state.activePage * state.perPage, state.totalResults);
      const reachedEnd = state.totalResults > 0 && state.totalPages > 0 && state.activePage >= state.totalPages;

      if (reachedEnd) {
        progressEl.textContent = i18n.allLoaded.replace('[[total]]', state.totalResults);
      } else {
        progressEl.textContent = i18n.progress.replace('[[end]]', end).replace('[[total]]', state.totalResults);
      }
    }

    /** Show/hide the Load More button based on state. */
    function updateLoadMore() {
      if (!loadMoreBtn) return;
      if (state.highestPage >= state.totalPages) {
        loadMoreBtn.hidden = true;
      } else {
        loadMoreBtn.hidden = false;
        loadMoreBtn.href = pageHref(state.highestPage + 1);
        loadMoreBtn.dataset.loading = 'false';
        if (loadMoreText) loadMoreText.textContent = i18n.loadMore;
        if (spinnerEl) spinnerEl.hidden = true;
      }
    }

    /** Show the skeleton grid, hide the main grid. */
    function showSkeleton() {
      if (skeletonGrid) {
        skeletonGrid.removeAttribute('hidden');
        skeletonGrid.classList.add('collection__grid--skeleton');
      }
      grid.setAttribute('hidden', '');
      if (paginationWrapper) paginationWrapper.hidden = true;
    }

    /** Hide skeleton, reveal the main grid and pagination. */
    function hideSkeleton() {
      grid.removeAttribute('hidden');
      if (skeletonGrid) skeletonGrid.setAttribute('hidden', '');
      if (paginationWrapper) {
        paginationWrapper.hidden = state.totalPages <= 1;
      }
    }

    /**
     * Generate the array of page indicators to render.
     * Returns numbers and the string '…' for ellipses.
     * @param {number} current
     * @param {number} total
     * @returns {Array<number|string>}
     */
    function generatePageNumbers(current, total) {
      if (total <= 7) {
        const arr = [];
        for (let i = 1; i <= total; i++) arr.push(i);
        return arr;
      }
      if (current <= 4) return [1, 2, 3, 4, 5, '…', total];
      if (current >= total - 3) return [1, '…', total - 4, total - 3, total - 2, total - 1, total];
      return [1, '…', current - 1, current, current + 1, '…', total];
    }

    /**
     * Build the href for a given page number.
     * @param {number} page
     * @returns {string}
     */
    function pageHref(page) {
      const url = new URL(window.location.href);
      if (page === 1) url.searchParams.delete('page');
      else url.searchParams.set('page', String(page));
      return url.pathname + url.search;
    }

    /** Render the numbered pagination nav. */
    function renderNav() {
      if (!navEl || state.totalPages <= 1) {
        if (navEl) {
          navEl.hidden = true;
          navEl.replaceChildren();
        }
        return;
      }
      navEl.hidden = false;

      const pages = generatePageNumbers(state.activePage, state.totalPages);
      const fragment = document.createDocumentFragment();

      // Previous arrow
      if (state.activePage > 1) {
        const prev = document.createElement('a');
        prev.href = pageHref(state.activePage - 1);
        prev.className = 'collection-pagination__page collection-pagination__arrow';
        prev.textContent = i18n.previous;
        prev.setAttribute('aria-label', i18n.previous);
        prev.dataset.page = String(state.activePage - 1);
        fragment.appendChild(prev);
      }

      // Page numbers
      pages.forEach(function (p) {
        if (p === '…') {
          const span = document.createElement('span');
          span.className = 'collection-pagination__ellipsis';
          span.textContent = '…';
          span.setAttribute('aria-hidden', 'true');
          fragment.appendChild(span);
        } else {
          const a = document.createElement('a');
          a.href = pageHref(p);
          a.className = 'collection-pagination__page';
          a.textContent = String(p);
          a.setAttribute('aria-label', i18n.page.replace('[[page]]', p));
          a.dataset.page = String(p);
          if (p === state.activePage) {
            a.dataset.state = 'current';
            a.setAttribute('aria-current', 'page');
          } else if (p >= state.lowestPage && p <= state.highestPage) {
            a.dataset.state = 'old';
          } else {
            a.dataset.state = 'new';
          }
          fragment.appendChild(a);
        }
      });

      // Next arrow
      if (state.activePage < state.totalPages) {
        const next = document.createElement('a');
        next.href = pageHref(state.activePage + 1);
        next.className = 'collection-pagination__page collection-pagination__arrow';
        next.textContent = i18n.next;
        next.setAttribute('aria-label', i18n.next);
        next.dataset.page = String(state.activePage + 1);
        fragment.appendChild(next);
      }

      navEl.replaceChildren(fragment);
    }

    /** Refresh all pagination UI sub-components. */
    function refreshPaginationUI() {
      updateProgress();
      updateLoadMore();
      renderNav();
    }

    /**
     * Stamp the first card of a freshly-rendered fragment with a
     * `data-page-anchor="N"` attribute so we can later smooth-scroll
     * to it when the visitor clicks an "old" page number. Falls back
     * gracefully if the fragment is empty.
     * @param {DocumentFragment} fragment
     * @param {number} page
     */
    function stampPageAnchor(fragment, page) {
      if (!fragment || !fragment.firstElementChild) return;
      fragment.firstElementChild.dataset.pageAnchor = String(page);
    }

    /**
     * Smooth-scroll the viewport so the first card of the given page
     * sits just below the sticky chrome (header + filter bar). Falls
     * back to scrolling the collection top if the anchor can't be
     * found (e.g. partial last page).
     * @param {number} page
     */
    function scrollToPage(page) {
      const anchor = grid.querySelector('[data-page-anchor="' + page + '"]');
      if (!anchor) {
        if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      // Account for the sticky header + sticky filter bar above the
      // grid so the page's first row isn't hidden underneath them.
      const headerHeight =
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      const filterBar = document.querySelector('.collection-upper__filters');
      const filterHeight = filterBar ? filterBar.getBoundingClientRect().height : 0;
      const offset = headerHeight + filterHeight + 12;
      const top = anchor.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    /**
     * Fetch and append the next page after `state.highestPage`. Used
     * by both the Load More button and the page-number "new" click
     * loop. Returns true if a page was added, false otherwise.
     * @returns {Promise<boolean>}
     */
    async function loadAppendNext() {
      if (state.isFetching || state.highestPage >= state.totalPages) return false;
      state.isFetching = true;
      try {
        const nextPage = state.highestPage + 1;
        const body = await fetchResults(nextPage);
        if (body && body.aborted) return false;
        if (!body || body.error) {
          revealFallback();
          return false;
        }
        if (!body.data || !body.data.results || body.data.results.length === 0) return false;

        const responseId = body.data.meta?.responseId || body.data.meta?.uid || body.data.responseId;

        state.highestPage = nextPage;
        state.activePage = nextPage;
        state.displayedCount += body.data.results.length;

        const fragment = renderCards(body.data.results, responseId);
        stampPageAnchor(fragment, nextPage);
        const newCards = Array.from(fragment.children);
        grid.appendChild(fragment);
        lazyLoadCards(grid);

        if (window.AthosBeacon && responseId) {
          window.AthosBeacon.sendCategoryRender(responseId);
          observeImpressions(responseId, body.data.results, newCards);
        }

        updateURL(nextPage, false);
        refreshPaginationUI();
        return true;
      } catch (err) {
        // Silent catch
        return false;
      } finally {
        state.isFetching = false;
      }
    }

    /**
     * Fetch and prepend the page before `state.lowestPage`, preserving
     * the visitor's scroll position so the viewport doesn't jump.
     * Mirrors loadAppendNext for the "new" page-number click loop in
     * the upward direction.
     * @returns {Promise<boolean>}
     */
    async function loadPrependPrevious() {
      if (state.isFetching || state.lowestPage <= 1) return false;
      state.isFetching = true;
      try {
        const prevPage = state.lowestPage - 1;
        const scrollBefore = window.scrollY;

        const body = await fetchResults(prevPage);
        if (body && body.aborted) return false;
        if (!body || body.error) {
          revealFallback();
          return false;
        }
        if (!body.data || !body.data.results || body.data.results.length === 0) return false;

        const responseId = body.data.meta?.responseId || body.data.meta?.uid || body.data.responseId;

        state.lowestPage = prevPage;
        state.displayedCount += body.data.results.length;

        const fragment = renderCards(body.data.results, responseId);
        stampPageAnchor(fragment, prevPage);
        const newCards = Array.from(fragment.children);

        const heightBefore = grid.scrollHeight;
        grid.insertBefore(fragment, grid.firstChild);
        lazyLoadCards(grid);

        if (window.AthosBeacon && responseId) {
          window.AthosBeacon.sendCategoryRender(responseId);
          observeImpressions(responseId, body.data.results, newCards);
        }

        const heightAfter = grid.scrollHeight;
        const heightDelta = heightAfter - heightBefore;
        window.scrollTo({ top: scrollBefore + heightDelta, behavior: 'instant' });

        updateURL(state.activePage, false);
        refreshPaginationUI();
        return true;
      } catch (err) {
        // Silent catch
        return false;
      } finally {
        state.isFetching = false;
      }
    }

    /** Read the page number from the current URL. Defaults to 1. */
    function getPageFromURL() {
      const params = new URLSearchParams(window.location.search);
      const p = parseInt(params.get('page'), 10);
      return Number.isFinite(p) && p > 0 ? p : 1;
    }

    /**
     * Update the browser URL without a hard reload.
     * @param {number} page
     * @param {boolean} push - true for pushState, false for replaceState
     */
    function updateURL(page, push) {
      const url = pageHref(page);
      if (push) {
        window.history.pushState({ ssPage: page }, '', url);
      } else {
        window.history.replaceState({ ssPage: page }, '', url);
      }
    }

    /**
     * Fetch a single page and replace the entire grid.
     * Used for initial load, page-number clicks, and popstate.
     * @param {number} page
     * @param {object} [opts]
     * @param {boolean} [opts.showSkeleton] - show skeleton during load
     * @param {boolean} [opts.scroll] - scroll to top of grid
     * @param {boolean} [opts.push] - use pushState instead of replaceState
     */
    async function loadPage(page, opts) {
      if (state.isFetching) {
        state.pendingLoad = { page: page, opts: opts };
        return;
      }
      state.isFetching = true;
      opts = opts || {};

      const emptyEl = document.querySelector('[data-js="collection-empty"]');
      if (emptyEl) emptyEl.setAttribute('hidden', '');

      if (opts.showSkeleton) showSkeleton();

      try {
        const body = await fetchResults(page);
        if (!body || body.error || body.aborted) {
          // While a filter is active the server grid holds the unfiltered
          // products, so revealing it would read as "the filter did nothing".
          // Show the empty state instead; fall back to the server grid only
          // for an unfiltered view (e.g. a transient error on first load).
          if (window.CollectionSortFilter && Object.keys(window.CollectionSortFilter.getParams()).length > 0) {
            if (skeletonGrid) skeletonGrid.setAttribute('hidden', '');
            grid.setAttribute('hidden', '');
            if (emptyEl) emptyEl.removeAttribute('hidden');
            if (paginationWrapper) paginationWrapper.hidden = true;
            updateProductCount(0);
          } else {
            revealFallback();
          }
          return;
        }
        if (!body.data || !body.data.results || body.data.results.length === 0) {
          if (page > 1) {
            loadPage(1, { showSkeleton: true, scroll: true, push: false });
            return;
          }
          if (window.CollectionSortFilter && Object.keys(window.CollectionSortFilter.getParams()).length > 0) {
            if (skeletonGrid) skeletonGrid.setAttribute('hidden', '');
            grid.setAttribute('hidden', '');
            const emptyEl = document.querySelector('[data-js="collection-empty"]');
            if (emptyEl) emptyEl.removeAttribute('hidden');
            if (paginationWrapper) paginationWrapper.hidden = true;
            updateProductCount(0);
          } else {
            revealFallback();
          }
          return;
        }

        const responseId = body.data.meta?.responseId || body.data.meta?.uid || body.data.responseId;
        if (window.AthosBeacon && responseId) {
          window.AthosBeacon.sendCategoryRender(responseId);
        }

        // Feed sort/filter UI with response data
        if (window.CollectionSortFilter) {
          window.CollectionSortFilter.handleResponse(body.data);
        }

        const pag = body.data.pagination || {};
        state.totalPages = pag.totalPages || 1;
        state.totalResults = pag.totalResults || 0;
        state.perPage = pag.perPage || 24;
        state.activePage = page;
        state.lowestPage = page;
        state.highestPage = page;
        state.displayedCount = body.data.results.length;

        updateProductCount(state.totalResults);

        const fragment = renderCards(body.data.results, responseId);
        stampPageAnchor(fragment, page);
        const newCards = Array.from(fragment.children);
        disconnectObservers();
        grid.replaceChildren(fragment);
        hideSkeleton();
        if (initialGridRender) {
          initialGridRender = false;
          prioritiseLeadImages(newCards, 2);
          grid.setAttribute('data-cards-resolving', '');
          setTimeout(() => {
            grid.removeAttribute('data-cards-resolving');
          }, 700);
        }
        lazyLoadCards(grid);

        if (window.AthosBeacon && responseId) {
          observeImpressions(responseId, body.data.results, newCards);
        }

        refreshPaginationUI();

        if (opts.push) {
          updateURL(page, true);
        } else {
          updateURL(page, false);
        }

        if (opts.scroll && scrollTarget) {
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } catch (err) {
        revealFallback();
        // Silent catch
      } finally {
        state.isFetching = false;
        if (state.pendingLoad) {
          const pending = state.pendingLoad;
          state.pendingLoad = null;
          if (pending.page !== state.activePage) loadPage(pending.page, pending.opts);
        }
      }
    }

    /** Handle "Load More" click — append next page. */
    async function handleLoadMore(e) {
      if (e) e.preventDefault();
      if (state.isFetching || state.highestPage >= state.totalPages) return;

      // Button UI: show spinner while the shared loader runs.
      if (loadMoreBtn) loadMoreBtn.dataset.loading = 'true';
      if (loadMoreText) loadMoreText.hidden = true;
      if (spinnerEl) spinnerEl.hidden = false;

      try {
        await loadAppendNext();
      } finally {
        if (loadMoreBtn) loadMoreBtn.dataset.loading = 'false';
        if (loadMoreText) loadMoreText.hidden = false;
        if (spinnerEl) spinnerEl.hidden = true;
      }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', handleLoadMore);
    }

    // Page number nav — event delegation on the nav container.
    // Click behaviour depends on the page's state:
    //   - current: ignored (also has pointer-events: none in CSS).
    //   - old: page already loaded in the DOM — smooth-scroll to its
    //     first card, no network fetch, no skeleton.
    //   - new: fetch every missing page sequentially (so the grid is
    //     contiguous), then smooth-scroll to the target page's first
    //     card.
    if (navEl) {
      navEl.addEventListener('click', async function (e) {
        const link = e.target.closest('[data-page]');
        if (!link) return;
        e.preventDefault();
        const page = parseInt(link.dataset.page, 10);
        if (!Number.isFinite(page) || page === state.activePage) return;

        // Already loaded — just scroll and update the active marker.
        if (page >= state.lowestPage && page <= state.highestPage) {
          state.activePage = page;
          updateURL(page, true);
          refreshPaginationUI();
          scrollToPage(page);
          return;
        }

        // New page — load every page between highestPage+1 and target
        // (or lowestPage-1 down to target). We disable the nav while
        // fetching so rapid clicks can't pile up requests.
        if (state.isFetching) return;
        navEl.setAttribute('aria-busy', 'true');
        navEl.style.pointerEvents = 'none';
        try {
          if (page === state.highestPage + 1) {
            const ok = await loadAppendNext();
            if (ok) {
              state.activePage = page;
              updateURL(page, true);
              refreshPaginationUI();
              scrollToPage(page);
            }
          } else if (page === state.lowestPage - 1) {
            const ok = await loadPrependPrevious();
            if (ok) {
              state.activePage = page;
              updateURL(page, true);
              refreshPaginationUI();
              scrollToPage(page);
            }
          } else {
            loadPage(page, { showSkeleton: true, scroll: true, push: true });
            return;
          }
        } finally {
          navEl.removeAttribute('aria-busy');
          navEl.style.pointerEvents = '';
        }
      });
    }

    // History: popstate for Back/Forward
    window.addEventListener('popstate', function (e) {
      const page = e.state && e.state.ssPage ? e.state.ssPage : getPageFromURL();
      loadPage(page, { showSkeleton: true, scroll: true, push: false });
    });

    if (grid) {
      grid.addEventListener('click', function (e) {
        if (!e.target.closest('a[href]')) return;
        const card = e.target.closest('[data-js="product-card"]');
        if (!card || !window.AthosBeacon) return;
        const data = cardDataMap.get(card);
        if (data && data.responseId && data.result) {
          window.AthosBeacon.sendCategoryClickthrough(data.responseId, data.result);
        }
      });

      grid.addEventListener('quick-add:added', function (e) {
        const card = e.target.closest('[data-js="product-card"]');
        if (!card || !window.AthosBeacon) return;
        const data = cardDataMap.get(card);
        if (data && data.responseId && data.result) {
          const addedItem = e.detail && e.detail.item ? e.detail.item : null;
          window.AthosBeacon.sendCategoryAddtocart(data.responseId, data.result, addedItem);
        }
      });
    }

    window.CollectionGrid = Object.freeze({
      /**
       * Reload the grid from page 1 with current sort/filter params.
       * Called by collection-sort-filter.js when user changes sort or filters.
       * @param {Object} [_params] - Ignored; params are read from CollectionSortFilter.getParams()
       * @param {Object} [opts] - Reload options
       */
      reload: function (_params, opts) {
        const scroll = opts && opts.scroll !== undefined ? opts.scroll : true;
        loadPage(1, { showSkeleton: false, scroll: scroll, push: false });
      },
    });

    // Count-only preview for the staged mobile filter drawer: fetch the total for
    // the currently staged params without rendering, so the "view X items" button
    // updates live. Aborts any in-flight preview before starting the next.
    let previewController = null;
    if (window.CollectionSortFilter && typeof window.CollectionSortFilter.registerPreview === 'function') {
      window.CollectionSortFilter.registerPreview(async function () {
        if (previewController) previewController.abort();
        previewController = new AbortController();
        const filters = window.CollectionSortFilter.getParams();
        const res = await window.AthosAPI.fetchCategory({
          handle,
          page: 1,
          resultsPerPage: 1,
          filters,
          signal: previewController.signal,
        });
        if (res && res.ok && res.data && res.data.pagination) {
          return res.data.pagination.totalResults;
        }
        return null;
      });
    }

    const initialPage = getPageFromURL();
    if (!(initialPage === 1 && !new URLSearchParams(window.location.search).has('page'))) {
      window.history.replaceState({ ssPage: initialPage }, '', window.location.href);
    }
    loadPage(initialPage, { showSkeleton: false, scroll: false, push: false });
  })();
